import { Spinner } from '@pms-digital/design-system';

/** The first read of the history is under way. */
export function ChargementHistorique() {
  return (
    <output className="flex items-center gap-3 text-body text-gray-700">
      <Spinner size="sm" label="" />
      Chargement de l'historique...
    </output>
  );
}
